export default {"src":"/_next/static/media/deposit-rewards.a78dc662.svg","height":349,"width":425,"blurWidth":0,"blurHeight":0};